import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c61415"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeTable = _resolveComponent("HomeTable")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeTable, {
      onClickNew: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('/dashboard'))),
      onClickMng: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('/mng-projects'))),
      onClickCloud: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('/cloud-services'))),
      onClickContrib: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('/contrib'))),
      onClickData: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('/mng-data')))
    })
  ], 512)), [
    [_vShow, _ctx.$store.getters.getSignedIn == true]
  ])
}